//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { out_stock, schoolClass, vms_store, stock_order } from "@/api/server";
import { wms_order_back } from "@/api/wms";
import { Drawer } from "iview";
import { mapState } from "vuex";
const obj = {
	APPLY: "申领",
	BORROW: "借用",
	BACK: "归还",
	PURCHASE: "入库",
	INVENTORY: "盘点"
};
const obj2 = {
	REJECTED: "被驳回",
	PICK: "待领物",
	COMPLETE: "已完成",
	CANCEL: "已撤回",
	COMMIT: "待提交",
	RETURNING: "正在归还",
	PENDING: "审核中"
};

const obj3 = {
	SELFUSE: "自用",
	CLASSUSE: "班级使用",
	COMMON: "部门使用",
	ORTHER: "外借"
};
export default {
	data() {
		return {
			orderList: {
				stocks: [],
				qrcode: null
			},
			visible: false,
			borrowVisible: false
		};
	},
	components: {
		Drawer
	},
	methods: {
		openOrder(id) {
			this.visible = true;
			stock_order.get({ id: id }).then(res => {
				if (res.data) {
					res.data.type_str = obj[res.data.type];
					res.data.status_str = obj2[res.data.status];
					if (res.data.apply_info) {
						res.data.usetype_str =
							obj3[res.data.apply_info.use_type];
					}

					switch (res.data.type) {
						case "BACK":
							res.data.stocks = res.data.out_stocks;
							res.data.stocks.forEach(v => {
								v.quantity = v.number;
								if (v.stock) {
									v.name = v.stock.name;
									v.position_no = v.stock.position_no;
									v.thumbnail = v.stock.thumbnail;
									v.barcode = v.stock.barcode;
								}
							});
							break;
						case "PURCHASE":
							res.data.stocks.forEach(v => {
								v.quantity = v.number;
								if (v.product) {
									v.thumbnail = v.product.thumbnail;
								}
							});
							break;
						default:
							res.data.stocks.forEach(v => {
								if (v.stock) {
									v.name = v.stock.name;
									v.position_no = v.stock.position_no;
									v.thumbnail = v.stock.thumbnail;
									v.barcode = v.stock.barcode;
								}
							});
					}

					this.orderList = res.data;

					if (
						this.orderList.method != "SCAN" &&
						(this.orderList.type == "APPLY" ||
							this.orderList.type == "BORROW")
					) {
						if (
							this.orderList.status == "PICK" ||
							this.orderList.status == "CONFIRM"
						) {
							this.orderList.step = 3;
						} else if (this.orderList.status == "PENDING") {
							this.orderList.step = 2;
						} else if (this.orderList.status == "COMPLETE") {
							this.orderList.step = 4;
						} else {
							this.orderList.step = 1;
						}
					}
					// this.$nextTick(() => {
					//     vms_store
					//         .getLimitQrcode({
					//             path: "pages/manage/backDetail/main",
					//             scene: `id=${id}`,
					//             client: "wms"
					//         })
					//         .then(res1 => {
					//             if (res1.data) {
					//                 this.orderList.qrcode = res1.data;
					//                 this.borrowVisible = true;
					//             } else {
					//                 this.borrowVisible = true;
					//             }
					//         });
					// });
				}
			});
		},
		// 关闭抽屉
		close() {
			this.visible = false;
		},

		putAllorder() {
			if (
				this.orderList.type == "APPLY" ||
				this.orderList.type == "BORROW"
			) {
				this.putOutOrder();
			} else {
				this.putBackOrder();
			}
		},

		putBackOrder() {
               
			let Header = ["", ""];
			let data = [];
			data.push(["单号:", this.orderList.id]);
			data.push(["出单日期:", this.orderList.add_time_str]);
			data.push([""]);
			data.push(["物资", this.orderList.type == 'BACK' ? "归还数量" : '入库数量']);
			this.orderList.stocks.forEach(v => {
				data.push([v.name, v.quantity]);
			});
              
			import("@/vendor/Export2Excel").then(excel => {
				excel.export_json_to_excel({
					header: Header,
					data,
					filename: "订单详情",
					autoWidth: true,
					bookType: "xlsx"
				});
			});
		},

		putOutOrder() {
			let Header = ["", "", "", "", ""];
			let data = [];
			data.push(["订单状态:", this.orderList.status_str]);
			data.push(["申请单号:", this.orderList.no]);
			data.push(["申请人:", this.orderList.user.name]);
			data.push(["申请类型:", this.orderList.type_str]);
			data.push(["使用类型:", this.orderList.usetype_str]);
			if (this.orderList.apply_info) {
				this.orderList.apply_info.use_type == "CLASSUSE" &&
					this.orderList.apply_info.use_class
					? data.push([
						"领用班级:",
						this.orderList.apply_info.use_class.enroll_year +
						" " +
						this.orderList.apply_info.use_class.name
					])
					: "";
				this.orderList.apply_info.use_type == "COMMON" &&
					this.orderList.apply_info.use_department
					? data.push([
						"使用部门:",
						this.orderList.apply_info.use_department.name
					])
					: "";
				this.orderList.apply_info.use_type == "ORTHER" &&
					this.orderList.apply_info.company
					? data.push([
						"借用单位:",
						this.orderList.apply_info.company.name
					])
					: "";
				this.orderList.apply_info.use_type == "ORTHER" &&
					this.orderList.apply_info.company
					? data.push([
						"联系人:",
						this.orderList.apply_info.company.contacts +
						"" +
						this.orderList.apply_info.company.telephone
					])
					: "";
			}
			data.push(["领取位置:", this.orderList.storehouse.name]);
			if (
				this.orderList.check_data &&
				this.orderList.check_data.sub_states &&
				this.orderList.check_data.sub_states.length > 0 &&
				this.orderList.status == "PENDING"
			) {
				this.orderList.check_data.sub_states.forEach((v, index) => {
					v.checkers.forEach((f, index2) => {
						if (index == 0 && index2 == 0) {
							data.push(["审核人:", v.name, f.name]);
						} else {
							data.push(["", v.name, f.name]);
						}
					});
				});
			}
			if (
				this.orderList.check_data &&
				this.orderList.check_data.sub_states &&
				this.orderList.check_data.sub_states.length > 0 &&
				this.orderList.status != "PENDING"
			) {
				this.orderList.check_data.sub_states.forEach((v, index) => {
					v.checkers.forEach((f, index2) => {
						if (index == 0 && index2 == 0) {
							if (f.check && (f.check == 1 || f.check == 2)) {
								data.push(["审核人:", v.name, f.name]);
							} else {
								data.push(["审核人", "", ""]);
							}
						} else {
							if (f.check && (f.check == 1 || f.check == 2)) {
								data.push(["", v.name, f.name]);
							}
						}
					});
				});
			}
			this.orderList.confirmer.forEach((v, index) => {
				index == 0
					? data.push(["管理员", v.name])
					: data.push(["", v.name]);
			});
			this.orderList.handler && this.orderList.handler.name
				? data.push(["操作人", this.orderList.handler.name])
				: "";
			data.push(["备注", this.orderList.remark]);
			data.push([""]);
			data.push(["物资", "条形码", "申请数量", ""]);
			this.orderList.stocks.forEach(v => {
				data.push([
					v.name,
					v.barcode,
					v.quantity,
					"已领取"
				]);
			});
			import("@/vendor/Export2Excel").then(excel => {
				excel.export_json_to_excel({
					header: Header,
					data,
					filename: "订单详情",
					autoWidth: true,
					bookType: "xlsx"
				});
			});
		}
	}
};



// WEBPACK FOOTER //
// ./src/components/warehouse/order.vue